<template>
    <rkm-modal
        large
        ref="RkmModal"
        title="Vínculo - Fornecedor (ConectaSUS)"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        disabled
                        :value="`${model.nome}${model.cnpj ? ` - ${model.cnpj}` : ''}`"
                        label="Fornecedor (Cliente)"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-select
                        :options="form.conectasusFornecedores"
                        :validations="validations.conectasusFornecedor"
                        label="Fornecedor (ConectaSUS)"
                        show-default-option
                        text-field="descricao"
                        v-model="model.conectasusFornecedorId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                color="primary"
                @click="save"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase, unmask} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                conectasusFornecedor: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            fornecedor: this.getConectaSusRepository('webService.almoxarifado.cliente.fornecedor'),
        }
    },
    data: () => ({
        fornecedorId: null,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(fornecedorId) {
            this.fornecedorId = fornecedorId
            this.form = null
            this.model = null

            this.load()
            this.$refs.RkmModal.show()
        },
        load() {
            this.setLoading()

            this.repositories.fornecedor.edit(this.fornecedorId)
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        conectasusFornecedorId: this.model.conectasusFornecedorId,
                        nome: this.model.nome,
                        cnpj: this.model.cnpj ? this.unMaskCnpj(this.model.cnpj) : null,
                    }

                    this.repositories.fornecedor.update(this.fornecedorId, this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.showSaveNotification()
                            this.$emit('saved', response)
                            this.$refs.RkmModal.hide()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [error, repository, stringCase, unmask],
}
</script>